/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Intake_TitleInputs */

const en_us2_body_assessment_intake_title = /** @type {(inputs: Body_Assessment_Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The numbers the calculation needs`)
};

const pt_br2_body_assessment_intake_title = /** @type {(inputs: Body_Assessment_Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dados que o cálculo precisa`)
};

const es_419_body_assessment_intake_title = /** @type {(inputs: Body_Assessment_Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los datos que necesita el cálculo`)
};

const pt_pt2_body_assessment_intake_title = /** @type {(inputs: Body_Assessment_Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dados de que o cálculo precisa`)
};

const fr_fr2_body_assessment_intake_title = /** @type {(inputs: Body_Assessment_Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les données dont le calcul a besoin`)
};

const de_de2_body_assessment_intake_title = /** @type {(inputs: Body_Assessment_Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Angaben für die Berechnung`)
};

const it_it2_body_assessment_intake_title = /** @type {(inputs: Body_Assessment_Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I dati che servono al calcolo`)
};

/**
* | output |
* | --- |
* | "The numbers the calculation needs" |
*
* @param {Body_Assessment_Intake_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_intake_title = /** @type {((inputs?: Body_Assessment_Intake_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Intake_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_intake_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_intake_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_intake_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_intake_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_intake_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_intake_title(inputs)
	return en_us2_body_assessment_intake_title(inputs)
});
export { body_assessment_intake_title as "body-assessment.intake_title" }